import React, { Fragment } from "react";
import MUIDataTable from "mui-datatables";
import { Container } from "reactstrap";

import IconButton from "@material-ui/core/IconButton";
import SystemUpdateAltIcon from "@material-ui/icons/SystemUpdateAlt";

import CampaignsDeactivate from "./CampaignsDeactivate";

import { Grid, Tooltip } from "@material-ui/core/";
import CampaignsDownloadExcelReports from "./CampaignsDownloadExcelReports";

import { Spinner } from "./Spinner";

import Moment from "react-moment";

import { LoggedUserContext } from "../LoggedUserContext";
import CampaignsEmailStatus from "./CampaignsEmailStatus";
import CampaignsEmailCounter from "./CampaignsEmailCounter";
import { acquireToken } from "../adalConfig";
import axios from "axios";

import Swal from "sweetalert2";
import withReactContent from "sweetalert2-react-content";

const MySwal = withReactContent(Swal);

class CampaignsDataTable extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      items: props.data,
      downloadDetailsLoading: false,
    };
  }

  render() {
    const { downloadDetailsLoading } = this.state;
    const columns = [
      {
        name: "campaingName",
        label: "Campaign Name",
        options: {
          filter: true,
        },
      },
      {
        name: "campaingCreateDate",
        label: "Created Date",
        options: {
          filter: true,
          customBodyRender: (value) => {
            return <Moment format="MMMM Do YYYY, h:mm a">{value}</Moment>;
          },
        },
      },

      {
        name: "peopleOnCreation",
        label: "People on Creation",
        options: {
          filter: true,
        },
      },
      {
        name: "campaingId",
        label: " ",
        options: {
          filter: false,
          download: false,
          customBodyRender: (value) => {
            return (
              <Fragment>
                <Grid
                  container
                  direction="row"
                  justify="flex-start"
                  alignItems="center"
                  spacing={1}
                >
                  <Grid item>
                    <CampaignsDownloadExcelReports
                      value={value}
                      type={"Creation"}
                      info={"Email"}
                    />
                  </Grid>
                  <Grid item>
                    <CampaignsDownloadExcelReports
                      value={value}
                      type={"Creation"}
                      info={"Detail"}
                    />
                  </Grid>
                </Grid>
              </Fragment>
            );
          },
        },
      },
      {
        name: "peopleOnCreation",
        label: "People Now",
        options: {
          filter: true,
        },
      },
      {
        name: "campaingId",
        label: " ",
        options: {
          filter: false,
          download: false,

          customBodyRender: (value) => {
            return (
              <Fragment>
                <Grid
                  container
                  direction="row"
                  justify="flex-start"
                  alignItems="center"
                  spacing={1}
                >
                  <Grid item>
                    <CampaignsDownloadExcelReports value={value} type={"Now"} info={"Email"} />
                  </Grid>
                  <Grid item>
                    <CampaignsDownloadExcelReports value={value} type={"Now"} info={"Detail"} />
                  </Grid>
                </Grid>
              </Fragment>
            );
          },
        },
      },
      {
        name: "campaingId",
        label: "Options",
        options: {
          filter: false,
          download: false,

          customBodyRender: (value) => {
            return (
              <Fragment>
                <Grid
                  container
                  direction="row"
                  justify="flex-start"
                  alignItems="center"
                  spacing={1}
                >
                  <Grid item>
                    <CampaignsDeactivate id={value} value={this.props.active} />
                  </Grid>
                  <Grid item>
                    {downloadDetailsLoading ? (
                    <Spinner />
                    ) : (
                    <Tooltip title="Download Campaign Details">
                      <IconButton
                        style={{ backgroundColor: "#797991" }}
                        aria-label="Download Campaign Details"
                        onClick={() => {
                          this.downloadDetails(value);
                        }}
                      >
                        <SystemUpdateAltIcon />
                      </IconButton>
                    </Tooltip>
                    )}
                  </Grid>
                  <Grid item>
                    <CampaignsEmailStatus id={value} />
                  </Grid>
                </Grid>
              </Fragment>
            );
          },
        },
      },
      {
        name: "campaingId",
        label: "Status",
        options: {
            filter: false,
            download: false,

            customBodyRender: (value) => {
                return (
                    <Fragment>
                        <Grid
                            container
                            direction="row"
                            justify="flex-start"
                            alignItems="center"
                            spacing={1}
                        >
                            <Grid item>
                                <CampaignsEmailCounter id={value} />
                            </Grid>
                        </Grid>
                    </Fragment>
                );
            },
        },
      },
    ];

    const data = this.state.items;

    const options = {
      filter: true,
      selectableRows: "none",
      selectableRowsOnClick: false,
      filterType: "multiselect",
      responsive: "stacked",
      rowsPerPage: 10,
      viewColumns: false,
      rowsPerPageOptions: [5, 10, 15, 100],
    };

    return (
      <Container fluid>
        <MUIDataTable
          title={this.props.active ? "Active Campaigns" : "Archived Campaigns"}
          data={data}
          columns={columns}
          options={options}
        />
      </Container>
    );
  }

  downloadDetails = (value) => {
    this.setState({ downloadDetailsLoading: true });
    acquireToken().then((token) => {
      const url = `${process.env.REACT_APP_API_URL}/CampaingAPI/DownloadCampaingExcelReport/${value}`;

      axios
        .get(url, {
          headers: { Authorization: `Bearer ${token}` },
          responseType: "blob",
        })
        .then((response) => {
          const blob = new Blob([response.data], { type: "application/excel" });
          const url = window.URL.createObjectURL(blob);
          const link = document.createElement("a");
          link.href = url;
          link.setAttribute("download", "Campaign details.xlsx");
          document.body.appendChild(link);
          link.click();
          window.URL.revokeObjectURL(link);
          this.setState({ downloadDetailsLoading: false });
        })
        .catch((err) => {
          MySwal.fire({
            icon: "error",
            title: "An error has occurred while downloading the file",
            text: err,
            confirmButtonColor: "#FFE600",
            confirmButtonText: "<div style='color: black'>OK</div>",
          });
        });
    });
  };
}

CampaignsDataTable.contextType = LoggedUserContext;

export default CampaignsDataTable;
